import React from 'react';
import { useParams } from 'react-router-dom';

import Page from '../../components/Page';
import { SaleCalendarProvider } from '../../sections/employee/sale-calendar/SaleCalendarContext';
import SaleCalendarView from '../../sections/employee/sale-calendar/SaleCalendarView';
import SaleCalendarExtendedToolbar from '../../sections/employee/sale-calendar/SaleCalendarExtendedToolbar';

export default function SaleCalendar() {
  const params = useParams();

  return (
    <Page title="Kalendarz Sprzedażowy" sx={{ width: '100%', height: '100%' }}>
      <SaleCalendarProvider>
        <SaleCalendarExtendedToolbar />
        <SaleCalendarView />
      </SaleCalendarProvider>
    </Page>
  );
};
